<template>
  <div class="skills-card">
    <div class="card-header">
      <p class="title">{{ title }}</p>
      <div v-if="coefficient" class="coefficient-tag">
        <p>{{ coefficient }}</p>
      </div>
    </div>
    <div class="skills-list">
      <p v-for="skill in skills" :key="skill" class="skill">
        {{ $t(`skills.${skillStore.getFormattedSkillId(skill)}.name`) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const skillStore = useSkillsStore();

defineProps<{
  title: string
  skills: string[]
  coefficient?: string
}>();
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.skills-card {
  border: 1px solid var(--light-grey-color);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: var(--light-white-color);

  .card-header {
    display: flex;
    gap: 8px;
    align-items: center;

    .title {
      font-family: $bioSans;
      font-size: 14px;
      font-weight: 600;
      line-height: normal;
      color: var(--secondary-color);
      margin: 0;
    }

    .coefficient-tag {
      background-color: $primary-color;
      border-radius: 4px;
      padding: 2px 4px 3px 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        font-family: $bioSans;
        font-size: 10px;
        font-weight: 400;
        line-height: normal;
        color: $secondary-color;
        margin: 0;
      }
    }
  }

  .skills-list {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .skill {
      font-family: $bioSans;
      font-size: 12px;
      font-weight: 400;
      //line-height: 12px;
      color: var(--secondary-color);
      margin: 0;
    }
  }
}
</style>
